import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureInstallPrompt } from "@/lib/installPrompt";
import { installUkDateFormat } from "@/lib/dateUtil";

captureInstallPrompt();
installUkDateFormat(); // platform-wide dd/mm/yyyy

// Suppress benign ResizeObserver loop errors (they trigger the CRA dev overlay and block clicks)
const RO_ERR = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (RO_ERR.test(e.message || "")) e.stopImmediatePropagation();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Force clear old caches and re-register
    caches.keys().then(names => names.forEach(name => {
      if (name !== 'fixlr-v8' && name !== 'fixlr-api-v6') {
        caches.delete(name);
      }
    }));
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
